import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const scrollToCategories = () => {
    const featuredCategoriesSection = document.getElementById(
      "featured-categories"
    );
    if (featuredCategoriesSection) {
      featuredCategoriesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToJoinCommunity = () => {
    const joinCommunitySection = document.getElementById("join-community");
    if (joinCommunitySection) {
      joinCommunitySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* Add Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,400&display=swap"
        rel="stylesheet"
      />

      <div className="relative w-full overflow-hidden bg-[#1A2B4D] min-h-[90vh] flex items-center">
        {/* Background image with overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url("/images/banner_home.png")',
            backgroundPosition: "70% center",
          }}
        >
          <div className="absolute inset-0 bg-[#1A2B4D]/50"></div>
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 md:px-6 relative z-10 w-full max-w-full">
          <div className="max-w-2xl mx-auto md:mx-0 text-center md:text-left">
            <div
              className="inline-block px-4 py-1.5 mb-6 bg-gold/90 text-[#1A2B4D] font-light tracking-wider text-sm rounded-full animate-fade-in opacity-0 transform hover:scale-105 transition-all duration-300"
              style={{
                animationDelay: "0.1s",
                fontFamily: "'Cormorant Garamond', serif",
              }}
            >
              A New Way to Elevate Your Lifestyle
            </div>

            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight animate-fade-in opacity-0 tracking-wide"
              style={{
                animationDelay: "0.3s",
                fontFamily: "'Playfair Display', serif",
              }}
            >
              Where Smart Living Meets{" "}
              <span className="text-gold italic font-medium">
                Timeless Elegance
              </span>
            </h1>

            <p
              className="mt-6 text-lg text-white/90 max-w-xl mx-auto md:mx-0 animate-fade-in opacity-0 font-light tracking-wide leading-relaxed"
              style={{
                animationDelay: "0.5s",
                fontFamily: "'Cormorant Garamond', serif",
              }}
            >
              Join our community of smart, stylish women who are redefining
              beauty, health, and personal finance through elegance and
              intelligence.
            </p>

            <div
              className="mt-8 flex flex-col sm:flex-row gap-4 justify-center md:justify-start animate-fade-in opacity-0"
              style={{ animationDelay: "0.7s" }}
            >
              <Button
                size="lg"
                className="bg-[#2E3F66] hover:bg-[#1A2B4D] border border-gold/30 text-white hover:border-gold transition-all duration-300 shadow-lg group"
                onClick={scrollToCategories}
              >
                Explore Now
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>

              <Button
                variant="outline"
                size="lg"
                className="border-white text-white bg-[#1A2B4D]/30 hover:bg-white/10 hover:text-gold transition-all duration-300"
                onClick={scrollToJoinCommunity}
              >
                Start Your Glow Journey
              </Button>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background to-transparent"></div>
      </div>
    </>
  );
};

export default HeroSection;
